import {
  Box,
  Button,
  Flex,
  HStack,
  Text,
  useBreakpointValue,
} from '@chakra-ui/react'
import { whiteButtonStyle } from '../common/commonStyles'

export const Footer = () => {
  const isMobileView = useBreakpointValue({
    base: true,
    md: false,
  })
  return (
    <Box w='100%' pt='3rem' pb={'2rem'} background='#F3F3F5'>
      <Flex
        justifyContent={'space-between'}
        alignItems='center'
        maxW={'78.5rem'}
        mx='auto'
        flexDirection={isMobileView ? 'column' : 'row'}
        gap='1rem'
        paddingX={'1rem'}
      >
        <HStack spacing={'.5rem'}>
          {/*<Button style={whiteButtonStyle} size='xs'>
            Terms of Service
          </Button>
          <Button style={whiteButtonStyle} size='xs'>
            Privacy Policy
          </Button>*/}
          <Button onClick={() => window.open(`https://forms.gle/KNiyoei3cydDPuhu8`, '_blank')} style={whiteButtonStyle} size='xs'>
            Report issue
          </Button>
        </HStack>

        <Text fontSize='0.75rem' fontWeight={600} color='#000'>
          All rights reserved.
        </Text>
      </Flex>
    </Box>
  )
}
